import { Button } from "@/components/ui/button";
import { FlaskConical, Mail, Lock } from "lucide-react";
import { startGmailOAuth } from "@/components/GmailConnect";

export default function DemoBanner({ gmailConnected, subscribed, leaks = [], onUpgrade }) {
  if (gmailConnected && subscribed) return null;
  const locked = leaks.filter((l) => l.locked && l.status === "active");
  const lockedTotal = locked.reduce((s, l) => s + (l.amount || 0), 0);
  const teaser = gmailConnected && locked.length > 0;
  return (
    <div className={`rounded-md border p-4 flex flex-col sm:flex-row sm:items-center gap-3 ${teaser ? "border-[#00E676]/40 bg-[#00E676]/5" : "border-[#FFC857]/40 bg-[#FFC857]/5"}`} data-testid="demo-banner">
      <div className="flex items-start gap-3 min-w-0 flex-1">
        {teaser ? <Lock className="h-5 w-5 text-[#00E676] shrink-0 mt-0.5" /> : <FlaskConical className="h-5 w-5 text-[#FFC857] shrink-0 mt-0.5" />}
        <div className="min-w-0">
          <div className={`font-mono text-[10px] uppercase tracking-widest ${teaser ? "text-[#00E676]" : "text-[#FFC857]"}`}>
            {teaser ? "REAL LEAKS FOUND · LOCKED" : gmailConnected ? "PREVIEW MODE" : "SAMPLE DATA · PREVIEW MODE"}
          </div>
          <div className="text-sm text-[#F4F1EA] mt-0.5" data-testid="demo-banner-text">
            {teaser ? (
              <>We found <b>{locked.length} real charge{locked.length > 1 ? "s" : ""}</b> in your inbox totaling <b className="text-[#00E676]">${lockedTotal.toFixed(2)}</b>. Unlock to reveal who's charging you and start cancelling.</>
            ) : (
              <>
                {!gmailConnected && "These leaks are examples so you can see how Clawback works. "}
                {!subscribed && "Cancels, refunds and claims unlock with a membership."}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="flex gap-2 shrink-0">
        {!gmailConnected && (
          <Button variant="outline" size="sm" className="btn-outline-paper h-9" onClick={startGmailOAuth} data-testid="demo-banner-connect-gmail">
            <Mail className="h-4 w-4 mr-1" /> Scan my real inbox
          </Button>
        )}
        {!subscribed && (
          <Button size="sm" className="btn-emerald h-9" onClick={onUpgrade} data-testid="demo-banner-upgrade">
            <Lock className="h-4 w-4 mr-1" /> Unlock — from $8.25/mo
          </Button>
        )}
      </div>
    </div>
  );
}
